import { ReactElement } from 'react'

import { Contact } from '@features/contacts/types/contact'
import { useExpenseRevampFeatureFlags } from '@views/bills/hooks/useExpenseRevampFeatureFlags'
// Components should not depend on views; EXP-660 moves this modal out of views/.
import { CreateSupplierModal } from '@views/suppliers/elements/CreateSupplierModal'

import { LegacyCreateContactModal } from './elements/LegacyCreateContactModal'

interface CreateContactModalProps {
  defaultValues?: Partial<Contact>
  isSupplier?: boolean
  onContactCreate?: (contact: Contact) => void
}

export const CreateContactModal = ({
  defaultValues,
  isSupplier = true,
  onContactCreate,
}: CreateContactModalProps): ReactElement | null => {
  const { areFlagsLoading, isRevampedPurchaseListEnabled } = useExpenseRevampFeatureFlags()

  // Picking a modal before the flag resolves could swap it out from under an open form.
  if (areFlagsLoading) {
    return null
  }

  // The revamped modal only creates suppliers. Customers, and suppliers while the flag is off, stay on the legacy modal.
  if (isRevampedPurchaseListEnabled && isSupplier) {
    return <CreateSupplierModal defaultValues={defaultValues} onContactCreate={onContactCreate} />
  }

  return (
    <LegacyCreateContactModal defaultValues={defaultValues} isSupplier={isSupplier} onContactCreate={onContactCreate} />
  )
}
